// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._11q73evi{background:var(--_1bph63)}
._11q7p6wq{background:var(--_h7c3fk)}
._zulpu2gc{gap:var(--ds-space-100,8px)}
._18m915vq{overflow-y:hidden}
._1e0c1txw{display:flex}
._1ltvidpf{left:0}
._1pby1nn1{z-index:400}
._1reo1wug{overflow-x:auto}
._1ul91ob8{min-width:space.0}
._1xi2idpf{right:0}
._4cvr1h6o{align-items:center}
._4t3i1osq{height:100%}
._80omtlke{cursor:pointer}
._kqswh2mm{position:relative}
._kqswstnw{position:absolute}
._1bcru2gc:hover{padding-left:var(--ds-space-100,8px)}
._1qn1u2gc:hover{padding-right:var(--ds-space-100,8px)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlassian/conversation-assistant-ui-components/dist/esm/ui/horizontal-scroll-container/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,yBAAyB;AACpC,WAAW,yBAAyB;AACpC,WAAW,2BAA2B;AACtC,WAAW,iBAAiB;AAC5B,WAAW,YAAY;AACvB,WAAW,MAAM;AACjB,WAAW,WAAW;AACtB,WAAW,eAAe;AAC1B,WAAW,iBAAiB;AAC5B,WAAW,OAAO;AAClB,WAAW,kBAAkB;AAC7B,WAAW,WAAW;AACtB,WAAW,cAAc;AACzB,WAAW,iBAAiB;AAC5B,WAAW,iBAAiB;AAC5B,iBAAiB,oCAAoC;AACrD,iBAAiB,qCAAqC","sourcesContent":["._11q73evi{background:var(--_1bph63)}\n._11q7p6wq{background:var(--_h7c3fk)}\n._zulpu2gc{gap:var(--ds-space-100,8px)}\n._18m915vq{overflow-y:hidden}\n._1e0c1txw{display:flex}\n._1ltvidpf{left:0}\n._1pby1nn1{z-index:400}\n._1reo1wug{overflow-x:auto}\n._1ul91ob8{min-width:space.0}\n._1xi2idpf{right:0}\n._4cvr1h6o{align-items:center}\n._4t3i1osq{height:100%}\n._80omtlke{cursor:pointer}\n._kqswh2mm{position:relative}\n._kqswstnw{position:absolute}\n._1bcru2gc:hover{padding-left:var(--ds-space-100,8px)}\n._1qn1u2gc:hover{padding-right:var(--ds-space-100,8px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
